import React from 'react';
import { Link } from 'react-router-dom';
import { FiGithub, FiTwitter, FiLinkedin, FiInstagram } from '../../utils/icons';

const Footer: React.FC = () => {
  return (
    <footer className="bg-foreground border-t border-border py-8 animate-fadeIn">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="animate-slideInFromBottom" style={{ animationDelay: '0.1s' }}>
            <h3 className="text-lg font-semibold mb-4 bg-gradient-to-r from-primary to-accent text-transparent bg-clip-text">MATRIX FINANCE</h3>
            <p className="text-sm text-text/70">
              Your journey to financial freedom starts here. Get expert advice, learn, and grow with our AI-powered financial assistant.
            </p>
          </div>

          <div className="animate-slideInFromBottom" style={{ animationDelay: '0.2s' }}>
            <h4 className="font-medium mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li className="hover:translate-x-1 transition-transform"><Link to="/" className="text-sm text-text/70 hover:text-primary">Home</Link></li>
              <li className="hover:translate-x-1 transition-transform"><Link to="/dashboard" className="text-sm text-text/70 hover:text-primary">Dashboard</Link></li>
              <li className="hover:translate-x-1 transition-transform"><Link to="/chat" className="text-sm text-text/70 hover:text-primary">Chat with Expert</Link></li>
              <li className="hover:translate-x-1 transition-transform"><Link to="/blog" className="text-sm text-text/70 hover:text-primary">Financial Blog</Link></li>
            </ul>
          </div>

          <div className="animate-slideInFromBottom" style={{ animationDelay: '0.3s' }}>
            <h4 className="font-medium mb-4">Resources</h4>
            <ul className="space-y-2">
              <li className="hover:translate-x-1 transition-transform"><Link to="/help" className="text-sm text-text/70 hover:text-primary">Help Center</Link></li>
              <li className="hover:translate-x-1 transition-transform"><Link to="/faq" className="text-sm text-text/70 hover:text-primary">FAQ</Link></li>
              <li className="hover:translate-x-1 transition-transform"><Link to="/community" className="text-sm text-text/70 hover:text-primary">Community</Link></li>
              <li className="hover:translate-x-1 transition-transform"><Link to="/terms" className="text-sm text-text/70 hover:text-primary">Terms & Conditions</Link></li>
            </ul>
          </div>

          <div className="animate-slideInFromBottom" style={{ animationDelay: '0.4s' }}>
            <h4 className="font-medium mb-4">Connect with us</h4>
            <div className="flex space-x-4">
              <a href="https://twitter.com/matrixfinance" className="text-text/70 hover:text-primary transform hover:scale-110 transition-transform"><FiTwitter size={20} /></a>
              <a href="https://linkedin.com/company/matrixfinance" className="text-text/70 hover:text-primary transform hover:scale-110 transition-transform"><FiLinkedin size={20} /></a>
              <a href="https://instagram.com/matrixfinance" className="text-text/70 hover:text-primary transform hover:scale-110 transition-transform"><FiInstagram size={20} /></a>
              <a href="https://github.com/matrixfinance" className="text-text/70 hover:text-primary transform hover:scale-110 transition-transform"><FiGithub size={20} /></a>
            </div>
            <div className="mt-4">
              <p className="text-sm text-text/70">Subscribe to our newsletter</p>
              <div className="mt-2 flex">
                <input 
                  type="email" 
                  placeholder="Your email" 
                  className="bg-card text-sm border border-border rounded-l-lg px-3 py-2 focus:outline-none focus:ring-1 focus:ring-primary w-full"
                />
                <button className="bg-gradient-to-r from-primary to-accent px-3 py-2 rounded-r-lg text-white text-sm hover:shadow-glow transition-all">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-4 border-t border-border text-center text-xs text-text/50 animate-fadeIn" style={{ animationDelay: '0.5s' }}>
          <p>© {new Date().getFullYear()} Matrix Finance. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 